import { render } from "./LargeHeader.vue?vue&type=template&id=31b5ce88&scoped=true"
import script from "./LargeHeader.vue?vue&type=script&lang=js"
export * from "./LargeHeader.vue?vue&type=script&lang=js"

import "./LargeHeader.vue?vue&type=style&index=0&id=31b5ce88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31b5ce88"

export default script